import { render, staticRenderFns } from "./quickview.component.vue?vue&type=template&id=6940ec95&scoped=true"
import script from "./quickview.component.vue?vue&type=script&lang=js"
export * from "./quickview.component.vue?vue&type=script&lang=js"
import style0 from "./quickview.component.vue?vue&type=style&index=0&id=6940ec95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6940ec95",
  null
  
)

export default component.exports